import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Redirect, Route, withRouter } from 'react-router-dom';
import { getUserDetails } from '../modules/selectors';

const propTypes = {
  component: PropTypes.oneOfType([
    PropTypes.elementType,
    PropTypes.func,
  ]).isRequired,
  user: PropTypes.shape({
    agentNpn: PropTypes.string,
    token: PropTypes.string,
    userId: PropTypes.string,
    userRole: PropTypes.string,
  }),
  location: PropTypes.shape({
    search: PropTypes.string.isRequired,
  }).isRequired,
};
const defaultProps = {
  user: null,
};


/**
 * Behaves like a Route when signed in, otherwise it will redirect to signIn
 * Note: Only supports route rendering via "component"
 */
function PrivateRoute({ component: ChildComponent, user, ...rest }) {
  return (
    <Route
      {...rest}
      render={(props) => {
        if (user) {
          return <ChildComponent {...props} />;
        }
        return (
          <Redirect
            to={{
              pathname: '/signIn',
              state: { from: props.location },
            }}
          />
        );
      }}
    />
  );
}

function mapStateToProps(state) {
  return {
    user: getUserDetails(state),
  };
}
PrivateRoute.propTypes = propTypes;
PrivateRoute.defaultProps = defaultProps;
export default withRouter(connect(mapStateToProps)(PrivateRoute));
